import React, { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components'; 

const StyledFullScreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1030;
  background-color: rgba(42, 40, 40, 0.7);
  transition: opacity 200ms ease-out;
  opacity: 1;
`;

export const FullScreenOverlay = ({ onClickOutside = null, children }) => {
  // deny document scroll, when overlay is displayed
  const overlayRef = useRef(null);
  useLayoutEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.removeProperty('overflow');
    }
  });

  const onOverlayClickHandler = (event) => {
    // if user click only on overlay, not children
    if (onClickOutside && overlayRef.current === event.target) {
      onClickOutside();
    }
  }

  return <StyledFullScreenOverlay onClick={onOverlayClickHandler} ref={overlayRef}>{children}</StyledFullScreenOverlay>
}

